import { useState, useEffect } from "react";
import "./machine_css.css";
import NaviBar from "./NaviBar/NaviBar";
import HomeProduct from "./homeProduct/homeProduct";
import SearchBar from "./NaviBar/SearchBar";
import HomeBrand from "./homeProduct/HomeBrand";
import HomeCate from "./homeProduct/HomeCategory";
import BottomCard from "./ShoppingCart/BottomCart";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HomeStyleCategory from "./Category/HomeStyleCate";

function Home(props) {
  const { t } = useTranslation();
  const history = useNavigate();
  const machine = JSON.parse(localStorage.getItem("machine"));

  console.log("homePageMachine", machine);

  const {
    cart,
    setLoading,
    prods,
    add,
    decreStock,
    alterquantity,
    langs,
    remove,
    setShowCart,
    showCart,
    setlangs,
    themeColor,
    changePrice,
    promoRef,
  } = props;

  const goToALLProducts = () => {
    history(`/machineUI/category/cate/all/all`);
  };

  return (
    <div className="main-container">
      <div className="Navi"></div>
      <NaviBar
        setShowCart={setShowCart}
        setlangs={setlangs}
        cart={cart}
        langs={langs}
        setLoading={setLoading}
      />
      <SearchBar langs={langs} themeColor={themeColor} />
      {machine?.themeColor?.c_column === "2" ||
      machine?.themeColor?.c_column === "3" ? (
        <HomeStyleCategory langs={langs} />
      ) : (
        <div>
          <HomeProduct
            prods={prods}
            langs={langs}
            cart={cart}
            add={add}
            decreStock={decreStock}
            alterquantity={alterquantity}
            remove={remove}
          />

          <div className="view-more-button" onClick={goToALLProducts}>
            {t("VIEW MORE")}
          </div>

          {machine?.themeColor?.b_column &&
            machine?.themeColor?.b_column !== "0" && (
              <HomeBrand prods={prods} langs={langs} />
            )}
          {machine?.themeColor?.c_column &&
            machine?.themeColor?.c_column !== "0" && (
              <HomeCate prods={prods} langs={langs} />
            )}
        </div>
      )}

      <BottomCard
        promoRef={promoRef}
        changePrice={changePrice}
        cart={cart}
        setShowCart={setShowCart}
        showCart={showCart}
        prods={prods}
        langs={langs}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        remove={remove}
      />
      {showCart && <div></div>}
    </div>
  );
}
export default Home;
